// extracted by extract-css-chunks-webpack-plugin
module.exports = {"toggleIcon":"_2n-sw","icon":"_8UAmD","close":"C2TfS","wrapper":"ZmObW","itemWrapper":"_26Cno","question":"-zM5O","text":"D11NY","answer":"WHQbb","hideAnswer":"_9s5gA"};